import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

export function SubNav({ items, testId = "subnav" }) {
  const { pathname } = useLocation();
  const { t } = useLang();
  return (
    <div className="border-b border-gold/25 bg-parchment-card/80 backdrop-blur" data-testid={testId}>
      <div className="mx-auto flex max-w-7xl gap-2 overflow-x-auto px-6 py-2 lg:px-8">
        {items.map((i) => (
          <Link key={i.to} to={i.to} data-testid={`${testId}-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors lg:py-1.5 ${pathname === i.to ? "bg-crimson text-parchment" : "text-crimson hover:bg-gold-light"}`}>
            {t(i.label)}
          </Link>
        ))}
      </div>
    </div>
  );
}

export const ABOUT_NAV = [{ to: "/about", label: "About Us" }, { to: "/about/leadership", label: "Leadership" }];
export const CONTACT_NAV = [{ to: "/contact", label: "Contact Us" }, { to: "/contact/faq", label: "FAQ" }, { to: "/contact/connect", label: "Connect with us" }];
